import { __decorate } from "tslib";
import { anyTemplate } from "./../templates/Any";
import { getDefaultValue } from '@tencent/data-schema-core';
import { BaseState } from "./BaseState";
import { Action } from "./utils/Action";
import { requestParamSchema, requestResultSchema } from "./param/requestParamSchema";
import { StateDefine } from "./utils/StateDefine";
import { State } from 'vue-class-state';
import { getAnyDataSchema, getAnyStateFeatures } from "../stateCommon/any";
import { cloneDeep, forEach, isPlainObject, memoize } from "lodash-es";
const anyActions = {
  request: 'request',
  requestCgi: 'requestCgi'
};
const watcherSchema = {
  title: '单接口监听事件',
  type: 'object',
  fields: []
};
export class AnyState extends BaseState {
  constructor(collection, options) {
    super(collection, options);
    this.stateModel = 'any';
    this.ucTag = '单接口';
    this.features = {};
    // 初始参数。本来应该配置 query 和 body 的，但是因为场景比较特殊就不在这里配置了
    this.props = [];
    this.data = null;
    this.query = {};
    this.body = {};
    /**
     * 【单接口】获取 request 的 param schema，如果不存在，会返回 null。
     */
    this.getRequestParamSchema = memoize(paramType => {
      var _actionInfo$def$schem, _this$options$sourceC, _ans$fields, _allDynamics$wholeBod;
      const actionInfo = this.stateMeta.actionInfos.request;
      const querySchema = actionInfo === null || actionInfo === void 0 || (_actionInfo$def$schem = actionInfo.def.schema.actionArguments) === null || _actionInfo$def$schem === void 0 || (_actionInfo$def$schem = _actionInfo$def$schem.find(x => x.id === 'params')) === null || _actionInfo$def$schem === void 0 || (_actionInfo$def$schem = _actionInfo$def$schem.fields) === null || _actionInfo$def$schem === void 0 ? void 0 : _actionInfo$def$schem.find(x => x.id === paramType);
      if (!querySchema) return null;
      const allDynamics = (_this$options$sourceC = this.options.sourceConfig) === null || _this$options$sourceC === void 0 || (_this$options$sourceC = _this$options$sourceC.dynamicParams) === null || _this$options$sourceC === void 0 ? void 0 : _this$options$sourceC.request;
      const dynamicParamsCfgs = (allDynamics === null || allDynamics === void 0 ? void 0 : allDynamics[paramType]) || [];
      const ans = cloneDeep(querySchema);
      (_ans$fields = ans.fields) === null || _ans$fields === void 0 ? void 0 : _ans$fields.forEach(field => {
        const dynamicParam = dynamicParamsCfgs.find(x => x.id === field.id);
        if ((dynamicParam === null || dynamicParam === void 0 ? void 0 : dynamicParam.type) === 'js') {
          field['uc:tag'] = ['表达式'];
          field['xy:isDynamicParam'] = dynamicParam.value;
        }
        field['xy:isAnyStateParam'] = [paramType, field.id];
      });
      const wholeBodyExpr = paramType === 'body' && (allDynamics === null || allDynamics === void 0 || (_allDynamics$wholeBod = allDynamics.wholeBody) === null || _allDynamics$wholeBod === void 0 || (_allDynamics$wholeBod = _allDynamics$wholeBod[0]) === null || _allDynamics$wholeBod === void 0 ? void 0 : _allDynamics$wholeBod.value);
      if (wholeBodyExpr) {
        // 整个 body 都是表达式
        ans['uc:tag'] = ['表达式'];
        ans['xy:isDynamicParam'] = wholeBodyExpr;
      }
      ans['xy:isAnyStateParam'] = [paramType];
      return ans;
    });
    this.features = getAnyStateFeatures(this);
    this.initState();
    this.initQueryAndBody();
  }
  async init() {
    try {
      if (this.getActionSupported(anyActions.request)) {
        await this.dispatch(anyActions.request);
      }
    } catch (error) {
      throw error;
    }
  }
  /**
   * 【单接口】初始化 query 和 body
   */
  initQueryAndBody() {
    var _this$options$sourceC2;
    const defaultValuesLUT = ((_this$options$sourceC2 = this.options.sourceConfig) === null || _this$options$sourceC2 === void 0 ? void 0 : _this$options$sourceC2.anyStateInitValues) || {};
    ['query', 'body'].forEach(paramType => {
      const schema = this.getRequestParamSchema(paramType);
      let defaultValue = schema ? getDefaultValue(schema) : null;
      // query 需要保证是一个 object
      if (paramType === 'query' && !isPlainObject(defaultValue)) defaultValue = {};
      if (typeof defaultValue === 'object' && !!defaultValue) {
        forEach(defaultValuesLUT[paramType], (value, key) => {
          defaultValue[key] = cloneDeep(value);
        });
      }
      this[paramType] = defaultValue;
    });
  }
  async requsetAction(params) {
    const reqOpts = {};
    if (!params) {
      // 使用默认传参数
      if (this.features.hostRequestParams) {
        // eslint-disable-next-line no-param-reassign
        params = {
          query: this.query,
          body: this.body
        };
      }
    } else {
      // 使用指定的参数
      reqOpts.raw = true;
    }
    const data = await this.collection.request(params, reqOpts);
    this.data = data.body;
    return {
      success: true,
      data: data.body
    };
  }
  registerWatcher() {
    // nothing
  }
}
AnyState.template = anyTemplate;
AnyState.watcherSchema = watcherSchema;
AnyState.stateModel = 'any';
__decorate([StateDefine(getAnyDataSchema), State], AnyState.prototype, "data", void 0);
__decorate([StateDefine(function () {
  const raw = this.features.hostRequestParams && this.getRequestParamSchema('query');
  if (!raw) return Object.freeze({
    type: 'any'
  });
  const schema = cloneDeep(raw || {
    type: 'object',
    fields: []
  });
  schema.id = 'query';
  schema.title = '请求query';
  schema['xy:isAnyStateParam'] = ['query'];
  return schema;
}), State], AnyState.prototype, "query", void 0);
__decorate([StateDefine(function () {
  const raw = this.features.hostRequestParams && this.getRequestParamSchema('body');
  if (!raw) return Object.freeze({
    type: 'any'
  });
  const schema = cloneDeep(raw);
  schema.id = 'body';
  schema.title = '请求body';
  schema['xy:isAnyStateParam'] = ['body'];
  return schema;
}), State], AnyState.prototype, "body", void 0);
__decorate([Action(anyActions.request, {
  cgiDeps: ['request'],
  schema: {
    title: '请求并写入',
    id: anyActions.request,
    description: '调用**request**接口,获取数据后写入到**data**',
    actionArguments: [requestParamSchema],
    actionReturnValue: requestResultSchema
  },
  defineArgs: state => [{
    ...state.getCgiParamSchema('request'),
    ...requestParamSchema
  }]
})], AnyState.prototype, "requsetAction", null);
//# sourceMappingURL=AnyState.js.map
